import { maxBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const screenReaderOnly = css`
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
`;

export const list = css`
  width: 182px;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: ${pxToRem(spacing.md)};
  row-gap: ${pxToRem(spacing.md)};
  margin: 0;
  padding: 0;

  ${mediaQuery(
    { min: 362 },
    css`
      width: auto;
    `,
  )};

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      margin: ${spacing.md}px 0;
    `,
  )};

  li {
    height: ${pxToRem(spacing.xxl)};
  }
`;
